export default function Slogan() {
  return (
    <div className="flex justify-center bg-blue_lightest py-2.5">
      <p className="text-xs">Qual é seu forte? Estatística ou sorte?</p>
    </div>
  );
}
